import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { MarketingFacade } from '../../../facades/marketing.facade';
import { ImageUtils } from '../../../utils/image.utils';

@Component({
  selector: 'app-configurable-mini-cart',
  templateUrl: './configurable-mini-cart.component.html',
  styleUrls: ['./configurable-mini-cart.component.scss'],
  standalone: false,
})
export class ConfigurableMiniCartComponent {
  @Input() currency!: string;
  @Input() currentCartId!: string;
  @Input() currentCartName!: string;
  @Input() usersCarts!: any[];
  @Input() itemsInCart!: any[];
  @Input() hasNickname!: boolean;

  @Output() closeMiniCart: EventEmitter<void> = new EventEmitter<void>();
  @Output() showAddNicknameModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() showDeleteQuoteModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() redirectToHomepage: EventEmitter<void> = new EventEmitter<void>();

  private readonly marketingFacade: MarketingFacade = inject(MarketingFacade);

  showAddNicknameModalEmit(): void {
    this.showAddNicknameModal.emit(true);
  }

  showDeleteQuoteModalEmit(): void {
    this.showDeleteQuoteModal.emit(true);
  }

  switchDefaultCart(cartId: string): void {
    this.marketingFacade.switchDefaultCart(cartId);
    this.redirectToHomepage.emit();
  }

  getItemPicture(item: any): string {
    return ImageUtils.getProductImageUrl(item);
  }

  getItemPrice(item: any): number {
    const cpqNetPrices: any[] = item.items.reduce((acc: any, data: any) => {
      acc.push(data.attributes.cpqNetPrice);
      return acc;
    }, []);

    return cpqNetPrices.reduce((total: any, price: any) => {
      return total + price;
    }, 0);
  }

  getEquipmentCount(item: any): number {
    const materialNumbers: any[] = [
      ...new Set(
        item.items.map((item: any) => item.attributes.systemDetails.materialNumber)
      )
    ];

    return materialNumbers ? materialNumbers.length : 0;
  }

  getAddOrEditNicknameLabel(): string {
    return this.hasNickname ? 'mini-cart.edit-nickname-label' : 'mini-cart.add-nickname-label';
  }

  /**
   * Closes the mini cart after a link is clicked.
   * Emits the closeMiniCart event to notify parent components.
   */
  closeMiniCartAfterClickOnLink(): void {
    this.closeMiniCart.emit();
  }
}
